import { Button, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import useAddEditRewardModalStore from "./hooks/useAddEditRewardModalStore"
import { useRewardTemplatesModal } from "./RewardTemplates"
import RewardCarousel from "../../components/carousel/RewardCarousel"
import DiamondRow from "../../components/diamondRow/DiamondRow"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"

export const RewardsEmpty = () => {
  const { onOpen: openRewardTemplateModal } = useRewardTemplatesModal()
  const { onOpen: openAddRewardModal } = useAddEditRewardModalStore()
  const { t } = useTranslation()
  const rewardItems = rewardItemsBase.map((item) => ({
    ...item,
    title: t(item.titleKey),
  }))

  const onCreateCustomRewardClick = () => {
    trackAnalyticEvent(ANALYTIC_EVENTS.EMPTY_STATE_CREATE_CUSTOM, {
      type: "custom_reward",
    })
    openAddRewardModal()
  }

  const onOpenTemplatesClick = () => {
    trackAnalyticEvent(ANALYTIC_EVENTS.EMPTY_STATE_OPEN_TEMPLATES, {
      type: "custom_reward",
    })
    openRewardTemplateModal()
  }

  return (
    <div className="flex flex-col items-center justify-center gap-6 mt-4">
      <Typography variant="bodyBold">
        {t("REWARD_EMPTY_CREATE_TO_START")}
      </Typography>
      <div className="flex flex-col gap-2 w-8/10">
        <Button
          onClick={onOpenTemplatesClick}
          text={t("REWARD_VIEW_RECOMMENDED")}
          fullWidth
        />
        <Button
          onClick={onCreateCustomRewardClick}
          text={t("REWARD_CREATE_MY_OWN")}
          buttonType="secondary"
          fullWidth
        />
      </div>
      <DiamondRow />
      <div className="flex flex-col gap-2 items-center text-center">
        <Typography variant="bodyBold">{t("REWARD_INSPIRE")}</Typography>
        <Typography variant="body">{t("REWARD_INSPIRE_SUB")}</Typography>
      </div>
      <RewardCarousel items={rewardItems} />
    </div>
  )
}

const rewardItemsBase = [
  { id: "1", titleKey: "REWARD_CAROUSEL_1", icon: "📱" },
  { id: "2", titleKey: "REWARD_CAROUSEL_2", icon: "💸" },
  { id: "3", titleKey: "REWARD_CAROUSEL_3", icon: "🎮" },
  { id: "4", titleKey: "REWARD_CAROUSEL_4", icon: "🍬" },
  { id: "5", titleKey: "REWARD_CAROUSEL_5", icon: "🧩" },
  { id: "6", titleKey: "REWARD_CAROUSEL_6", icon: "🌳" },
  { id: "7", titleKey: "REWARD_CAROUSEL_7", icon: "📚" },
  { id: "8", titleKey: "REWARD_CAROUSEL_8", icon: "🎨" },
  { id: "9", titleKey: "REWARD_CAROUSEL_9", icon: "🍕" },
  { id: "10", titleKey: "REWARD_CAROUSEL_10", icon: "🚴‍♂️" },
  { id: "11", titleKey: "REWARD_CAROUSEL_11", icon: "🎥" },
  { id: "12", titleKey: "REWARD_CAROUSEL_12", icon: "🌌" },
] as const
